import { useMutation, useQueryClient } from "@tanstack/react-query";
import * as yup from "yup";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";
import { removeNullishFromShape } from "../../utilities/general";

export const AUTH_QUERY_PARAMS = {
  code: "code",
  hmac: "hmac",
  host: "host",
  shop: "shop",
  state: "state",
  timestamp: "timestamp",
};

const requestSchema = yup.object({
  isEnabled: yup.boolean().required(),
  syncProducts: yup.boolean().required(),
  [AUTH_QUERY_PARAMS.code]: yup.string().nullable(),
  [AUTH_QUERY_PARAMS.hmac]: yup.string().nullable(),
  [AUTH_QUERY_PARAMS.host]: yup.string().nullable(),
  [AUTH_QUERY_PARAMS.shop]: yup.string().nullable(),
  [AUTH_QUERY_PARAMS.state]: yup.string().nullable(),
  [AUTH_QUERY_PARAMS.timestamp]: yup.string().nullable(),
});

export const useSaveShopifyIntegrationDataMutation = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation(
    (dto) => {
      const req = requestSchema.validateSync(dto, {
        strict: true,
      });
      return http.post(
        HTTP_ENDPOINTS.saveShopifyDetails(),
        removeNullishFromShape({
          is_enabled: +req.isEnabled,
          sync_products: +req.syncProducts,
          code: req[AUTH_QUERY_PARAMS.code],
          hmac: req[AUTH_QUERY_PARAMS.hmac],
          host: req[AUTH_QUERY_PARAMS.host],
          shop: req[AUTH_QUERY_PARAMS.shop],
          state: req[AUTH_QUERY_PARAMS.state],
          timestamp: req[AUTH_QUERY_PARAMS.timestamp],
        }),
      );
    },
    {
      ...options,
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.shopifyAuthData],
        });
        options?.onSuccess?.();
      },
    },
  );
};
